import React from 'react';

import Header from 'components/header/Header/Header';
import Footer from 'components/common/Footer/Footer';

const withLayout = (WrappedComponent, customHeader, disableFooter) => {
  const Layout = props => (
    <div className="layout">
      {!customHeader && <Header />}
      <WrappedComponent {...props} />
      {!disableFooter && <Footer />}
    </div>
  );

  return Layout;
};

export default withLayout;
